import lazyLoadOnRender from '@ms/yammer-web-components/dist/lazy/loadOnRender';

const toastLoader = () => import(/* webpackChunkName: "4-feat-toast" */ '@ms/yammer-web-components/dist/toast/Toast');

export default lazyLoadOnRender({ loader: toastLoader });
